import React, { useMemo } from "react";
import dateFormat, { i18n } from "dateformat";
import { isWithinInterval } from "date-fns";
import {
  Calendar as ReactCalendar,
  CalendarTileProperties,
  FormatterCallback,
  DateCallback,
} from "react-calendar";

import { useCurrentWidth } from "../../hooks";
import { useBookingWindow } from "../../hooks/useBookingWindow";
import { MediaBreakPoints } from "../../resources/constants";
import { moscowNow } from "../../utils/date/moscowNow";

import "./calendar.scss";
import arrowLeftIcon from "../../assets/icons/arrowCalendarLeft.svg";
import arrowRightIcon from "../../assets/icons/arrowCalendarRight.svg";

import { CalendarPropsType } from "./types";
import { monthNamesForCalendar } from "../../resources/locale";

i18n.monthNames = monthNamesForCalendar;

export const Calendar: React.FC<CalendarPropsType> = (props) => {
  const {
    currentDate,
    region = "ru",
    maxDate,
    minDate,
    onSelectDate,
  } = props;

  const today = useMemo(() => moscowNow(), []);

  const effectiveCurrentDate = currentDate || today;

  // minDate — сегодня по Москве (как в мобилке, чтобы нельзя было уйти в прошлые месяцы)
  const effectiveMinDate = useMemo(() => {
    if (minDate) return minDate;
    const d = new Date(today);
    d.setHours(0, 0, 0, 0);
    return d;
  }, [minDate, today]);

  // Граница продаж с бэка (учитывает ранний доступ тренеров)
  const { maxDate: windowMaxDate } = useBookingWindow();
  const effectiveMaxDate = maxDate || windowMaxDate;

  const navBtnLeft = <img src={arrowLeftIcon} alt="prev button" />;
  const navBtnRight = <img src={arrowRightIcon} alt="next button" />;

  const windowWidth = useCurrentWidth();
  const breakpointDoubleView = MediaBreakPoints.MOBILE_LARGE;

  const handleSelectDate: DateCallback = (value) => {
    onSelectDate(value);
  };

  const tileDisabled = ({ date }: CalendarTileProperties) => {
    const firstEnableDate = new Date(today).setHours(0, 0, 0, 0);
    const lastEnableDate = new Date(effectiveMaxDate);
    lastEnableDate.setHours(23, 59, 59, 999);

    const enableRange = isWithinInterval(date, {
      start: firstEnableDate,
      end: lastEnableDate,
    });

    return !enableRange;
  };

  const formatMonth: FormatterCallback = (_, date) => dateFormat(date, "mmmm yyyy");

  return (
    <div>
      <ReactCalendar
        value={effectiveCurrentDate}
        locale={region}
        maxDate={effectiveMaxDate}
        minDate={effectiveMinDate}
        prevLabel={navBtnLeft}
        nextLabel={navBtnRight}
        showDoubleView={windowWidth > breakpointDoubleView ? true : false}
        showNeighboringMonth={true}
        defaultView="month"
        maxDetail="month"
        minDetail="month"
        onClickDay={handleSelectDate}
        tileDisabled={tileDisabled}
        formatMonthYear={formatMonth}
      />
    </div>
  );
};
